const DetermineIndexing = (pageIndexingRequested: boolean, env: Record<string, string>) => {
	return pageIndexingRequested && env?.ENVIRONMENT_NAME === 'prod';
};

export default DetermineIndexing;
